import React from 'react';
import './Footer.css';

// 로고 경로 처리 함수
const getLogoPath = (filename) => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const basePath = window.location.pathname.startsWith('/trading') ? '/trading' : '';
  return `${basePath || publicUrl}/images/${filename}`;
};

function Footer() {
  const isTradingPage = window.location.pathname.startsWith('/trading');
  
  return (
    <footer className="footer">
      {isTradingPage ? (
        // Trading 페이지 전용 Footer
        <div className="footer-content trading-footer">
          <div className="footer-text">
            <span className="trading-service-text">
              AI주식거래서비스-제우스 서비스 페이지입니다.
            </span>
            <span className="trading-service-link">
              by{' '}
              <a 
                href="https://star612.net" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-link"
                style={{ color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'underline' }}
              >
                Star612.net
              </a>
            </span>
          </div>
        </div>
      ) : (
        // 일반 페이지 Footer
        <>
          <div className="footer-content">
            <img 
              src={getLogoPath('logo-612w.png')} 
              alt="작은별612 로고" 
              className="footer-logo"
            />
            <div className="footer-text">
              <span className="copyright">Copyright © 2024 작은별612 All rights reserved.</span>
              <span className="address">경기도 부천시 부천로 198번길 18 춘의테크노파크 2차 202동 15층 AI콘텐츠 캠퍼스 15-12호</span>
            </div>
          </div>
          <div className="footer-links">
            <a 
              href="https://lotty.kr" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="footer-link"
            >
              LottyRobot
            </a>
            <a href="/legacy/product" className="footer-link footer-link--legacy">
              이전 제품 페이지
            </a>
          </div>
        </>
      )}
    </footer>
  );
}

export default Footer;